<template>
  <transition name="">
    <section class="opinion_search active" id="paperAllComment">
      <h2 class="hide">의견검색 레이어</h2>
      <button
        type="button"
        class="opinion_search_closed permit_everyone"
        @click="toggleCommentSearch"
      ></button>
      <!-- 전체 변경 2020-09-15 S -->
      <div v-if="commentList.length > 0" class="opinion-search_area">
        <input
          type="text"
          ref="searchInput"
          :placeholder="$i18nUtil.trans('message.placeholder.select.comment','작성자, 의견내용을 검색하세요.')"
          required="required"
          @input="typing"
          @keydown="typing"
          @keyup="typing"
        />
        <button type="button" class="btn_search" @click="resetSearch">
          {{$i18nUtil.trans("search.039","검색")}}
        </button>
      </div>
      <!-- 전체 변경 2020-09-15 S -->
      <div ref="scrollBox" class="scroll_box">
        <!-- 검색 내용 S -->
        <div class="no-data" v-if="commentList.length == 0"
             v-html="$i18nUtil.trans('message.BoardComment.002','작성된 의견이 없습니다.블록별 의견 아이콘을 클릭하여 의견을 작성해 보세요.')">
        </div>
        <div ref="searchBox">
          <div
            class="opinion_box name"
            v-for="(comment, index) in commentList"
            v-show="searchFilter(comment)"
            :class="comment.deleteYn ? 'del' : ''"
            :key="index"
            :id="'opidiv' + comment.commentId"
          >
            <template v-if="!comment.deleteYn">
              <div class="droplayer relative">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">
                      <b v-html="highlight(comment.regUserName)"> </b>
                    </v-btn>
                  </template>
                  <div class="dropdown-list">
                    <UserTooltip :userId="comment.regUserId" />
                  </div>
                </v-menu>
                <span class="date">{{
                  $moment(comment.regDate).format("YYYY.MM.DD HH:mm")
                }}</span>
              </div>

              <div
                class="txt"
                :class="comment.commentType === 'EMOTICON' ? 'reply-emoticon' : ''"
                @click="contentClick($event, comment)"
                v-html="highlight(comment.comment)"
              ></div>
            </template>
            <template v-else>
              <div class="txt">{{$i18nUtil.trans("message.OpinionSearch.002","삭제된 의견입니다.")}}</div>
            </template>
            <dl class="reply_box" v-if="comment.commentCount > 0">
              <dt class="active"
                  v-html="$i18nUtil.trans('search.000.reply','총 {cnt} 건의 답변',{cnt:comment.commentCount})">
              </dt>
              <dd>
                <div
                  class="opinion_box"
                  v-for="(reply, index) in commentMap[comment.commentId]
                    .replyList"
                  :key="index"
                  v-show="searchFilter(reply)"
                  :class="reply.deleteYn ? 'del' : ''"
                >
                  <template v-if="!reply.deleteYn">
                    <div class="name">
                      <div class="droplayer relative">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">
                              <b v-html="highlight(reply.regUserName)"></b>
                            </v-btn>
                          </template>
                          <div class="dropdown-list">
                            <UserTooltip :userId="reply.regUserId" />
                          </div>
                        </v-menu>
                      </div>
                      <span class="date">
                        {{ $moment(reply.regDate).format("YYYY.MM.DD HH:mm") }}
                      </span>
                    </div>
                    <div
                      class="txt"
                      :class="comment.commentType === 'EMOTICON' ? 'reply-emoticon' : ''"
                      @click="contentClick($event, reply)"
                      v-html="highlight(reply.comment)"
                    ></div>
                  </template>
                  <template v-else>
                    <div class="txt">{{$i18nUtil.trans("message.ProjectComment.008","삭제된 답변입니다.")}}</div>
                  </template>
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <!-- //opinion_box -->
        <div class="no-data" v-if="commentList.length > 0 && isNoData">
          {{$i18nUtil.trans("search.013","검색 결과가 없습니다.")}}<br />
        </div>
        <!-- 검색 내용 E -->
      </div>

      <div class="info-txt" v-if="commentList.length > 0"
           v-html="$i18nUtil.trans('message.BoardComment.003','블록별 의견 아이콘을 클릭하여 의견을 작성해 보세요.')">
      </div>
      <!-- //scroll_box -->
    </section>
  </transition>
</template>

<script>
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import lodash from "lodash";

export default {
  components: {
    UserTooltip,
  },
  props: {
    boardUtil: Object,
    paperInfo: Object,
    blockInfo: Object,
    userInfo: Object,
    memberSelector: Object,
    boardMemberInfo: Object,
  },
  data() {
    return {
      show: false,
      modalSmall: false,
      editorData: {
        paperId: "",
        contents: "",
        paperFileId: "",
        userId: "",
        fileName: "",
      },
      commentMap: {},
      commentList: [],
      search: "",
      isNoData: false,
      memberSearchOpen: true,
      elementObserver: false,
      tenantId: localStorage.getItem("tenantId"),
    };
  },
  mounted() {
    let self = this;
    self.editorData.paperId = self.$route.params.paperId;
    {
      /* 의견창이 닫히면 멤버호출 창도 닫혀야 한다. */
      let element = document.getElementById("paperAllComment");
      if (self.elementObserver) { self.elementObserver.disconnect(); }
      self.elementObserver = new MutationObserver((list, obs) => {
        for (let inx = 0, item = null; inx < list.length && (item = list[inx].target); inx++) {
          if (item.classList.contains("active")) {
            if(this.tenantId != "201"){
              self.memberSelector.cancelMemberSelect(self.$refs.searchInput);
            }
            break;
          }
        }
      });
      self.elementObserver.observe(element, { attributes: true });
    }
  },
  created() {
    EventBus.$off("commentedAll");
    EventBus.$on("commentedAll", this.refresh);
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("coworkUtils", ["CHECK_AND_LAUNCH"]),
    toggleCommentSearch() {
      document.getElementById("paperAllComment").classList.toggle("active");
    },
    viewHidden(param) {
      var con = document.getElementById("dl_dropdown" + param);
      if (con.style.display == "none") {
        con.style.display = "block";
      } else {
        con.style.display = "none";
      }
    },
    refresh() {
      let self = this;
      if (document.getElementById("paperAllComment").classList.length >= 2) {
        let reqData = {};
        reqData.url = "/api/copaper/opinion/commentListAll";
        reqData.method = "post";
        reqData.params = self.editorData;
        self.COWORK_REST_SIMPLE_ACTION(reqData).then((resp) => {
          if (!resp) {
            return;
          }
          if (resp.errorCode) {
            console.log('/commentListAll errorCode ', resp.errorCode);
          }
          // locale에 따른 사용자명 표기
          let list = resp.result;
          if(list != null) {
            list.forEach(item => {
              if(item.commentType === "EMOTICON") {
                item.comment = self.$emoticonFn.getEmoticonImg(self.tenantId, item.emoticonId);
              }
              if(item.emoticonId != null || item.emoticonId != ''){
                item.comment = item.comment.replace('/mneo/OKRCOWORK_FRONTEND_NATIVE','');
        }

              if(self.$i18nUtil.getLanguage() === 'ko') {

              }else{
                item.regUserName = item.regUserNameEn != null ? item.regUserNameEn : item.regUserName;
              }
            })
          }

          let result = list;
          let commentList = self.commentList;
          let commentMap = self.commentMap;
          commentList.splice(0, commentList.length);
          for (let k in commentMap) {
            delete commentMap[k];
          }
          let fnGetMap = (commentId, comment) => {
            if (!commentMap[commentId]) {
              commentMap[commentId] = { comment, replyList: [] };
            } else if (!comment) {
              comment = commentMap[commentId].comment;
            }
            if (comment) {
              comment.commentCount = commentMap[commentId].replyList.length;
            }
            return commentMap[commentId];
          };
          for (let inx = 0; result && inx < result.length; inx++) {
            let comment = result[inx];
            if (!comment.parentCommentId) {
              commentList.push(comment);
              fnGetMap(comment.commentId, comment);
            } else {
              let parent = fnGetMap(comment.parentCommentId);
              parent.replyList.push(comment);
              if (parent.comment) {
                parent.comment.commentCount = parent.replyList.length;
              }
              fnGetMap(comment.commentId, comment);
            }
          }
          {
            // 최초 진입시 가장최근 의견으로 이동 (최하단 으로 스크롤)
            self.CHECK_AND_LAUNCH({ check(ctx) {
              let panelHeight = self.$refs.searchBox ? self.$refs.searchBox.offsetHeight : 0;
              let scrollBoxHeight = self.$refs.scrollBox ? self.$refs.scrollBox.offsetHeight : 0;
              if (!ctx.panelHeight || ctx.panelHeight != panelHeight) {
                ctx.panelHeight = panelHeight;
                ctx.scrollBoxHeight = scrollBoxHeight;
                return false;
              }
              return true;
            }, launch(ctx) {
              let panelHeight = ctx.panelHeight;
              let scrollBoxHeight = ctx.scrollBoxHeight;
              let scrollTop = ctx.panelHeight - ctx.scrollBoxHeight + 50;
              if (scrollTop < 0) { scrollTop = 0; }
              self.$refs.scrollBox.scrollTop = scrollTop;
            }, interval: 200 });
          }
        });
      }
    },
    openModal() {
      this.modalSmall = true;
    },
    closeModal() {
      this.modalSmall = false;
    },
    commentCount(comment) {
      let ret = 0;
      for (let inx in this.commentList) {
        if (this.commentList[inx].commentId === comment.parentCommentId) {
          ret++;
        }
      }
      return ret;
    },
    searchFilter(comment) {
      let replyList = this.commentMap[comment.commentId].replyList;
      let fncCheck = (comment) => {
        if (!this.search) { return true; }
        if (this.search &&
          comment.deleteYn != 1 && comment.regUserName != null && (
            comment.comment.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            comment.regUserName.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          )) {
          return true;
        }
        return false;
      };
      let chk = fncCheck(comment);
      if (!chk && replyList.length > 0) {
        for (let inx in replyList) {
          if ((chk = fncCheck(replyList[inx]))) {
            break;
          }
        }
      }
      if (chk && this.isNoData) {
        this.isNoData = false;
      }
      return chk;
    },
    contentClick($event, comment) {
      EventBus.$emit("contentBlockMatched", comment);
    },
    memberSearchPos(pos, caret) {
      let scrollY = window.scrollY || window.pageYOffset;
      let offsetTop = this.$el.offsetTop + scrollY;
      let offsetLeft = this.$el.offsetLeft - this.$el.offsetWidth ;
      offsetTop += caret.parentNode.offsetTop;
      offsetLeft += caret.parentNode.offsetLeft;
      pos.top = offsetTop - caret.offsetTop + 20;
      pos.left = offsetLeft - caret.offsetLeft + 20;
      pos.reverse = true;
    },
    memberSearchSelect(cancel, item, caret) {
      let text = item ? item.getAttribute("data-user-name") : "";
      if (!cancel && text) {
        this.search = text;
        this.isNoData = true;
        caret.element.value = text;
      }
    },
    typing(e) {
      let self = this;
      let target = e.target;
      lodash.debounce(() => {
        let search = null;
        if (e.target.value.length > 0) {
          search = e.target.value;
          search = search.replace(/</g, "&lt;").replace(/>/g, "&gt;");
          search = search.replace(/^[ \t\r\n\0]+/, "");
          search = search.replace(/[ \t\r\n\0]+$/, "");
        }
        self.search = search;
        self.isNoData = true;
      }, 100)();
    },
    resetSearch() {
      this.memberSelector.cancelMemberSelect(this.$refs.searchInput);
      this.$refs.searchInput.value = "";
      this.search = "";
      this.isNoData = true;
      this.memberSearchOpen = true;
    },
    highlightNode (element, search, caseIgnore) {
      let node = element.firstChild;
      if (search && caseIgnore) {
        search = search.toLowerCase();
      }
      for (let node = element.firstChild;node ; node = node.nextSibling) {
        if (node.nodeName == "#text") {
          let result = "";
          let orig = node.nodeValue;
          let text = orig;
          if (caseIgnore) {
            text = text.toLowerCase();
          }
          let pp = 0;
          for (let cp = 0; (cp = text.indexOf(search, cp)) != -1;) {
            let textNode = document.createTextNode(orig.substring(pp, cp));
            let spanNode = document.createElement("span");
            spanNode.classList.add("highlight");
            spanNode.innerText = orig.substring(cp, cp + search.length);
            element.insertBefore(textNode, node);
            element.insertBefore(spanNode, node);
            cp += search.length;
            pp = cp;
          }
          node.nodeValue = text.substring(pp);
        }
        else {
          this.highlightNode(node, search);
        }
      }
    },
    highlight(text) {
      if (!text) { text = ""; }
      let search = this.search;
      if (search) {
        let element = document.createElement("div");
        element.innerHTML = text;
        this.highlightNode(element, search, true);
        text = element.innerHTML;
      }
      return text;
    },
  },
};
</script>
<style scoped>
.name .droplayer .v-menu__content {
  width: 260px;
  border: 0 none;
  background-color: transparent;
}

.opinion_search .info-txt {
  position: relative;
}

.opinion_search {
  overflow: hidden;
}

/* .opinion_box.del {
  display: table;
} */

div.txt {
  cursor: pointer;
}

.opinion_box .txt {
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/comment/CommentSearch.vue